"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEnv = void 0;
const is_browser_1 = require("./utils/is-browser");
/**
 * Reads all safe environment variables from the browser or all environment
 * variables from the server.
 */
function allEnv() {
    if ((0, is_browser_1.isBrowser)()) {
        // eslint-disable-next-line no-underscore-dangle
        return window.__ENV;
    }
    return process.env;
}
exports.allEnv = allEnv;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWxsLWVudi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9hbGwtZW52LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLG1EQUErQztBQUUvQzs7O0dBR0c7QUFDSCxTQUFnQixNQUFNO0lBQ3BCLElBQUksSUFBQSxzQkFBUyxHQUFFLEVBQUUsQ0FBQztRQUNoQixnREFBZ0Q7UUFDaEQsT0FBTyxNQUFNLENBQUMsS0FBSyxDQUFDO0lBQ3RCLENBQUM7SUFFRCxPQUFPLE9BQU8sQ0FBQyxHQUFHLENBQUM7QUFDckIsQ0FBQztBQVBELHdCQU9DIn0=